// -1 a < b
// 0 a = b
import { I_BASE_AGENT, I_UA_INFO } from './typing'

// 1 a > b
enum COMPARE_RESULT {
  LT = -1,
  EQ = 0,
  GL = 1,
}
export function compareVersion(_a?: string, _b?: string): COMPARE_RESULT {
  if (_a === _b || (!_a && !_b)) return COMPARE_RESULT.EQ
  const a: string[] = (_a || '').split('.')
  const b = (_b || '').split('.')
  const len = Math.max(a.length, b.length)
  let i: COMPARE_RESULT = COMPARE_RESULT.EQ
  do {
    if (Number(a[i]) < Number(b[i]) || !a[i]) return COMPARE_RESULT.LT
    else if (Number(a[i]) > Number(b[i]) || !b[i]) return COMPARE_RESULT.GL
    i++
  } while (i < len)
  return COMPARE_RESULT.EQ
}

function isMobile(_ua: string) {
  const ua: string = _ua.toLowerCase()
  const bIsIpad = ua.indexOf('ipad') !== -1
  const bIsIphoneOs = ua.indexOf('iphone') !== -1
  const bIsMidp = ua.indexOf('midp') !== -1
  const bIsUc7 = ua.indexOf('rv:1.2.3.4') !== -1
  const bIsUc = ua.indexOf('ucweb') !== -1
  const bIsAndroid = ua.indexOf('android') !== -1
  const bIsCE = ua.indexOf('windows ce') !== -1
  const bIsWM = ua.indexOf('windows mobile') !== -1
  const bIsWebview = ua.indexOf('webview') !== -1
  // 鸿蒙 native UA 没有上述移动端标识，需单独判断
  const bIsHarmonyNative = ua.indexOf('mt_web_ua') !== -1 && ua.indexOf('micromessenger') === -1 && ua.indexOf('knb') !== -1
  return bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsWebview || bIsHarmonyNative
}

function parseUserAgent(ua: string): I_UA_INFO {
  const uaInfo: I_UA_INFO = {}
  // remove bracket parts & split into pairs
  const uaPairs = ua.replace(/\([^)]+\)/g, '').split(/\s+/)
  let lastItemKey = ''
  for (const item of uaPairs) {
    if (!item) continue
    const split = item.lastIndexOf('/')
    if (split < 0) {
      lastItemKey = item
      uaInfo[item] = 'unknown'
    } else {
      let itemKey = item.slice(0, split)
      if (itemKey.indexOf('app/') === 0) {
        itemKey = 'version'
      }
      if (lastItemKey) {
        itemKey = `${lastItemKey} ${itemKey}`
        lastItemKey = ''
      }
      uaInfo[itemKey] = item.slice(split - item.length + 1)
    }
  }
  return uaInfo
}

function getIOSVersion(ua: string): string {
  if (/ipad|iphone/i.test(ua)) {
    const rs = new RegExp(/os (\d*(?:_\d)*) like mac os x/i).exec(ua)
    if (rs && rs.length > 0) return (rs[1] || '').replace(/_/g, '.')
  }
  return ''
}

function getAndroidVersion(ua: string): string {
  if (/android/i.test(ua)) {
    const rs = new RegExp(/android (\d*(?:.\d)*)/i).exec(ua)
    if (rs && rs.length > 0) return rs[1] || ''
  }
  return ''
}

export function agent(_ua = ''): I_BASE_AGENT {
  const ua = _ua.toLowerCase()
  const uaInfo = parseUserAgent(ua)
  const iosVersion = getIOSVersion(ua) || uaInfo.ios
  const androidVersion = getAndroidVersion(ua) || uaInfo.android
  const osVersion = iosVersion || androidVersion || 'Unknown'
  const Agent = {
    uaInfo,
    osVersion,
    ltios11: iosVersion ? compareVersion(iosVersion, '11') === -1 : false,
    iphone: ua.indexOf('iphone') !== -1,
    iphonex: /iphonex/gi.test(ua) || (/iphone/gi.test(ua) && window.screen.height >= 812),
    ipad: /ipad/.test(ua),
    android: ua.indexOf('android') !== -1,
    weibo: ua.indexOf('weibo') !== -1,
    // Mozilla/5.0 (iPhone; CPU iPhone OS 12_1_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.0 MQQBrowser/9.1.0 Mobile/16D57 Safari/604.1 MttCustomUA/2 QBWebViewType/1 WKType/1
    qq: ua.indexOf('qq') !== -1 && ua.indexOf('micromessenger') === -1,
    qzone: ua.indexOf('qzone') !== -1,
    // Mozilla/5.0 (iPhone; CPU iPhone OS 12_1_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/16D57 MicroMessenger/7.0.3(0x17000321) NetType/WIFI Language/zh_CN
    weixin: ua.indexOf('micromessenger') !== -1,
    // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_3) AppleWebKit/605.1.15 (KHTML, like Gecko) MicroMessenger/2.3.23(0x12031710) MacWechat NetType/WIFI pcwechat
    pcwechat: ua.indexOf('windowswechat') !== -1 || ua.indexOf('macwechat') !== -1,
    // Mozilla/5.0 (Linux; Android 10; OXF-AN10 Build/HUAWEIOXF-AN10; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/77.0.3865.120 MQQBrowser/6.2 TBS/045710 Mobile Safari/537.36 wxwork/3.1.10 ColorScheme/Dark MicroMessenger/7.0.1 NetType/WIFI Language/zh Lang/zh
    wxwork: ua.indexOf('wxwork') !== -1 && ua.indexOf('micromessenger') !== -1,
    native: ua.indexOf('titans') !== -1, // 公司内部APP
    harmonyNative: ua.indexOf('mt_web_ua') !== -1 && ua.indexOf('micromessenger') === -1 && ua.indexOf('knb') !== -1, // 鸿蒙app
    android_Ios_HarmonyNative:
      (ua.indexOf('mt_web_ua') !== -1 && ua.indexOf('micromessenger') === -1 && ua.indexOf('knb') !== -1) ||
      ua.indexOf('titans') !== -1, // 鸿蒙&安卓&苹果app
    pc: !isMobile(ua),
    wkwebview: ua.indexOf('wkwebview') !== -1,
    // Mozilla/5.0 (iPhone; CPU iPhone OS 13_1_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 swan/2.9.0 swan-baiduboxapp/11.12.0.18 baiduboxapp/11.12.0.18 (Baidu; P2 13.1.3)
    // Mozilla/5.0 (Linux; Android 9; Pixel 2 XL Build/PQ2A.190405.003; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/71.0.3578.99 Mobile Safari/537.36 swan/2.1.0 swan-xhsdiscover/5.49.0 (Baidu; P1 9)
    swan: ua.indexOf('swan/') !== -1 && ua.indexOf('swan-mibrowser') === -1,
    wide: document.documentElement.clientWidth > 575.98,
    miniprogram: false,
    anyminiprogram: false,
    msc: ua.indexOf('msc') !== -1, // msc小程序
    harmony: ua.indexOf('openharmony') !== -1, // 鸿蒙系统
    meituan: ua.indexOf('meituan') !== -1, // 美团APP
  }
  if (Agent.weixin) {
    // 从微信7.0.0开始，可以通过判断userAgent中包含miniProgram字样来判断小程序web-view环境，ios低版本仍依赖appnm
    Agent.miniprogram = ua.indexOf('miniprogram') !== -1
  }
  if (Agent.miniprogram || Agent.swan) {
    // 任意小程序
    Agent.anyminiprogram = true
  }
  return Agent
}

export function checkAgent(Agent: I_BASE_AGENT) {
  if (Agent.iphone && compareVersion(Agent.osVersion, '10.0.0') < 0) {
    return {
      status: -1,
      message: 'ios 版本过低可能存在未知问题，建议升级系统',
    }
  }
  if (Agent.android && compareVersion(Agent.osVersion, '5.0.0') < 0) {
    return {
      status: -2,
      message: '系统版本过低可能存在未知问题',
    }
  }
  if (Agent.weixin && !Agent.msc) {
    const isMiniProgram = window.__wxjs_environment === 'miniprogram'
    if (isMiniProgram && Agent.pcwechat) {
      return {
        status: -3,
        message: 'pc 微信小程序可能存在未知问题，建议手机访问',
      }
    }
    let updateNotice = false
    if (isMiniProgram && isMiniProgram !== Agent.miniprogram) {
      updateNotice = true
    }
    // 7.0.3 才支持 window.WeixinJSBridge.on('onPageStateChange', () => {})
    if (!Agent.pcwechat && !Agent.wxwork && compareVersion(Agent.uaInfo.micromessenger, '7.0.3') < 0) {
      updateNotice = true
    }
    if (updateNotice) {
      return {
        status: -4,
        message: '您的微信版本过低，为了避免影响页面正常使用，建议升级至最新版本',
      }
    }
  }
  return {
    status: 0,
  }
}

export default agent(navigator.userAgent)
